import React, { Component } from "react";
import { UserMenu, MenuItemLink } from "react-admin";
import Person from "@material-ui/icons/Person";
import Lock from "@material-ui/icons/Lock";

class CustomUserMenu extends Component {
  render() {
    return (
      <UserMenu {...this.props}>
        <MenuItemLink
          to="/profile"
          primaryText="My profile"
          leftIcon={<Person />}
        />
        <MenuItemLink
          to="/change-password"
          primaryText="Change password"
          leftIcon={<Lock />}
        />
      </UserMenu>
    );
  }
}

export default CustomUserMenu;
